import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Alert, Badge, Button, Card, Col, Container, Form, Nav, Pagination, Row, Spinner, Tab, Table, Tabs } from 'react-bootstrap';
import { FaArrowLeft } from 'react-icons/fa';
import Flag from 'react-world-flags';
import { getURLbyEndPointV2 } from '../../../../../store/api';
import { countryNameToCode } from '../../../../../store/countryCode';
import toast from "react-hot-toast";

const ParticipateCountry = ({ onCountrySelect, onSlotSelect, selectedSlots, setActiveGlobalTab }) => {
  const [activeTab, setActiveTab] = useState('countries');
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [showSlotAlert, setShowSlotAlert] = useState(false);
  const [registrationDetails, setRegistrationDetails] = useState(null);
  const countriesPerPage = 6;

 

  useEffect(() => {
    fetchCountries();
  }, []);

  const handleSlotSelect = (slot) => {
    const isSlotSelected = selectedSlots.some(
      s => s.slotId === slot._id && s.countryId === selectedCountry._id
    );

    let updatedSlots;
    if (isSlotSelected) {
      updatedSlots = selectedSlots.filter(
        s => !(s.slotId === slot._id && s.countryId === selectedCountry._id)
      );
    } else {
      updatedSlots = [...selectedSlots, {
        slotId: slot._id,
        countryId: selectedCountry._id,
        countryName: selectedCountry.country,
        companyName: selectedCountry.companyName,
        date: slot.date,
        price: slot.price,
        startTime: slot.startTime,
        endTime: slot.endTime,
        duration: slot.duration
      }];
    }

    onSlotSelect(updatedSlots);
  };

  const fetchCountries = async () => {
    try {
      setLoading(true);
      const response = await axios.get(getURLbyEndPointV2("getParticipateCountries"));
      // Sort countries: those with registrationId first
      const sortedCountries = response.data.data.sort((a, b) => {
        const aHasSlots = a.details.some(d => d.registrationId);
        const bHasSlots = b.details.some(d => d.registrationId);
        return bHasSlots - aHasSlots;
      });
      setCountries(sortedCountries);
    } catch (error) {
      console.error("Error fetching countries:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchRegistrationDetails = async (country, companyDetails) => {
    try {
      setLoading(true);
      const response = await axios.get(getURLbyEndPointV2(`getRegistrationDetail`) + country);
      const regDetails = response.data.data.find(reg =>
        reg.lawFirm === companyDetails.companyName
      );
      setRegistrationDetails(regDetails);
    } catch (error) {
      console.error("Error fetching registration details:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCountrySelect = (countryData) => {
    setSelectedCountry(countryData);
    setSelectedCompany(countryData.details[0]);
    fetchRegistrationDetails(countryData.country, countryData.details[0]);
    setActiveTab('countryDetails');
  };


  const handleDropdownSelect = (countryId) => {
    const countryData = countries.find(c => c._id === countryId);
    if (countryData) {
      handleCountrySelect(countryData);
    }
  };


  const renderCountriesList = () => {
    const indexOfLastCountry = currentPage * countriesPerPage;
    const indexOfFirstCountry = indexOfLastCountry - countriesPerPage;
    const currentCountries = countries.slice(indexOfFirstCountry, indexOfLastCountry);

    return (
      <>
        <Row className="mb-4">
          <Col md={6}>
            <Form.Select
              onChange={(e) => handleDropdownSelect(e.target.value)}
              defaultValue=""
            >
              <option value="" disabled>Select a country</option>
              {countries.map((country) => (
                <option key={country._id} value={country._id}>
                  {country.country}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>
        <Row className="justify-content-center g-4">
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            currentCountries.map((countryData) => {
              const hasSlots = countryData.details.some(d => d.registrationId);
              return (
                <Col key={countryData._id} xs={12} sm={6} md={4} lg={4}>
                  <Card
                    className="h-100 cursor-pointer border-1 shadow-sm"
                    onClick={() => handleCountrySelect(countryData)}
                  >
                    <Card.Body className="text-center">
                      <div className="d-flex gap-1 justify-content-center align-items-center">
                        <Flag
                          code={countryNameToCode[countryData.country]}
                          style={{ width: '80px', height: '40px', objectFit: 'cover' }}
                          className='border'
                        />
                      </div>
                      <Card.Title className="fw-semibold mt-2 fs-6 mb-0">
                        {countryData.country}
                      </Card.Title>
                      {hasSlots && (
                        <Badge bg="success" className="mt-2">
                          Slots Available
                        </Badge>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              );
            })
          )}

          {countries.length > countriesPerPage && (
            <div className="d-flex justify-content-center mt-4">
              <Pagination>
                <Pagination.Prev
                  onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                  disabled={currentPage === 1}
                />
                {Array.from({ length: Math.ceil(countries.length / countriesPerPage) }).map((_, idx) => (
                  <Pagination.Item
                    key={idx}
                    active={currentPage === idx + 1}
                    onClick={() => setCurrentPage(idx + 1)}
                  >
                    {idx + 1}
                  </Pagination.Item>
                ))}
                <Pagination.Next
                  onClick={() => setCurrentPage(p => Math.min(Math.ceil(countries.length / countriesPerPage), p + 1))}
                  disabled={currentPage === Math.ceil(countries.length / countriesPerPage)}
                />
              </Pagination>
            </div>
          )}
        </Row>
      </>
    );
  };

  const renderSlotBooking = () => {
    if (!registrationDetails) return null;

    const handleSlotAction = (slot) => {
      const isSelected = selectedSlots.some(
        s => s.slotId === slot._id && s.countryId === selectedCountry._id
      );
      handleSlotSelect(slot);
    };

    const renderSlotRow = (slot) => {
      const isSelected = selectedSlots.some(
        s => s.slotId === slot._id && s.countryId === selectedCountry._id
      );
      const status = slot.isBooked !== "Booked" ? "Available" : "Booked";
      const statusColor = slot.isBooked === "Pending" ? "success" : "danger";

      return (
        <tr key={slot._id}>
          <td>{new Date(slot.date).toISOString().split("T")[0]}</td>
          <td>{`${slot.startTime} - ${slot.endTime}`}</td>
          <td>{slot.duration} minutes</td>
          <td>
            <Badge bg={statusColor}>{status}</Badge>
          </td>
          <td>
            <Button
              size="sm"
              disabled={slot.isBooked === "Booked"}
              variant={isSelected ? "danger" : "primary"}
              onClick={() => handleSlotAction(slot)}
            >
              {isSelected ? "Remove" : "Select"}
            </Button>
          </td>
        </tr>
      );
    };

    return (
      <div className="mt-4">
        <h5>Available Time Slots</h5>
        <Table responsive bordered hover className="mt-3">
          <thead>
            <tr>
              <th>Date</th>
              <th>Time</th>
              <th>Duration</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {registrationDetails.slots.map(renderSlotRow)}
          </tbody>
        </Table>
      </div>
    );
  };

  const renderCountryDetails = () => {
    if (!selectedCountry || !selectedCompany) return null;

    return (
      <Container className="p-4">
        <div className="d-flex gap-1 justify-content-between align-items-center">
          <div className="d-flex gap-1 justify-content-center align-items-center">
            <Flag
              code={countryNameToCode[selectedCountry.country]}
              className="mb-3"
              style={{ width: '100px', height: '50px' }}
            />
            <h5 className="fw-bold">{selectedCountry.country}</h5>
          </div>
          <Button
            variant="outline-primary"
            size="sm"
            onClick={() => setActiveTab('countries')}
            className="mb-4"
          >
            <FaArrowLeft className="h-4 w-4 mr-2" /> Back to Countries
          </Button>
        </div>
        <hr />

        <div className='d-flex justify-content-end'>
          <Badge bg="primary" className='my-1'>{selectedCountry.details.length} Collaboration available</Badge>
        </div>

        {selectedCountry.details.length > 1 && (
          <Nav variant="pills" activeKey={selectedCompany?._id} className="mb-4">
            {selectedCountry.details.map((company) => (
              <Nav.Item key={company._id} className='me-2'>
                <Nav.Link
                  eventKey={company._id}
                  onClick={() => {
                    setSelectedCompany(company);
                    fetchRegistrationDetails(selectedCountry.country, company);
                  }}
                  style={{
                    backgroundColor: selectedCompany?._id === company._id ? '#007bff' : '#f4f4f9',
                    color: selectedCompany?._id === company._id ? '#fff' : '#495057',
                    borderRadius: '5px',
                    padding: '10px 15px',
                    cursor: 'pointer',
                  }}
                >
                  {company.companyName}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        )}

<div className="mb-4">
  <div className="d-flex align-items-center gap-3">
    {selectedCompany?.logoUrl && (
      <img
        src={selectedCompany.logoUrl}
        alt={`${selectedCompany.companyName} logo`}
        className='border'
        style={{
          width: '150px', // Adjust size as needed
          height: '150px',
          objectFit: 'contain', // Ensures the image fits nicely
        }}
      />
    )}
    <div>

    <h3 className="fw-bold">{selectedCompany?.companyName}</h3>
    <h6
            className="text-muted"
            dangerouslySetInnerHTML={{
              __html: (selectedCompany?.heading || '').replace(/\r\n/g, '<br />'),
            }}
            ></h6>
            </div>
  </div>
  <hr />
          <h5 className="mb-3">About</h5>

          <p
            className="text-muted text-justify"
            dangerouslySetInnerHTML={{
              __html: (selectedCompany?.description || '').replace(/\r\n/g, '<br />'),
            }}
          ></p>
        </div>

        {registrationDetails ? (
          <div>
            <Card className="shadow-sm p-3">
              <Tabs defaultActiveKey="industries" id="registration-tabs" className="mb-3">
                <Tab eventKey="industries" title="Industries">
                  <Card className="p-3 border-0">
                    <h4 className="text-primary fw-bold">Industries</h4>
                    <hr />
                    <div className="d-flex flex-wrap gap-2">
                      {registrationDetails?.industries?.map((industry, index) => (
                        <Badge key={index} bg="info" className="p-2 fw-semibold">
                          {industry}
                        </Badge>
                      ))}
                    </div>
                  </Card>
                </Tab>

                <Tab eventKey="expertise" title="Areas of Expertise">
                  <Card className="p-3 border-0">
                    <h4 className="fw-bold">Expertise Areas</h4>
                    <hr />
                    {Object.entries(registrationDetails?.expertise || {}).map(([area, services]) => (
                      <div key={area} className="mb-3">
                        <h6 className="fw-bold">{area}</h6>
                        <div className="d-flex flex-wrap gap-2">
                          {services.map((service, index) => (
                            <Badge key={index} bg="info" className="p-2 fw-semibold">
                              {service}
                            </Badge>
                          ))}
                        </div>
                      </div>
                    ))}
                  </Card>
                </Tab>

                <Tab eventKey="participants" title="Participants">
                  <Card className="p-3 border-0">
                    <h4 className="fw-bold">Participants</h4>
                    <hr />
                    <Table responsive bordered hover size="sm" className="mt-2">
                      <thead className="table-info">
                        <tr>
                          <th>Name</th>
                          <th>Designation</th>
                        </tr>
                      </thead>
                      <tbody>
                        {registrationDetails?.participants?.map((participant, index) => (
                          <tr key={index}>
                            <td>{`${participant.firstName} ${participant.lastName}`}</td>
                            <td>{participant.designation}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Card>
                </Tab>
              </Tabs>
            </Card>
            <div>
              {renderSlotBooking()}
            </div>
          </div>
        ) : (
          <div className="text-center">
            <Button
              variant="primary"
              onClick={() => setShowSlotAlert(true)}
              className="mb-3"
            >
              Book Slot
            </Button>
            {showSlotAlert && (
              <Alert
                variant="info"
                onClose={() => setShowSlotAlert(false)}
                dismissible
              >
                Slots will be available from March 1st, 2025
              </Alert>
            )}
          </div>
        )}

        <div className="d-flex justify-content-between mt-4">
          <Button
            variant="outline-primary"
            size="sm"
            onClick={() => setActiveTab('countries')}
          >
            Book other countries
          </Button>
          {selectedSlots.length > 0 && (
            <Button
              variant="primary"
              size="sm"
              onClick={() => setActiveGlobalTab('Slot & Payment')}
            >
              Proceed
            </Button>
          )}
        </div>
      </Container>
    );
  };

  return (
    <Container className="py-4">
      <Tab.Container activeKey={activeTab} onSelect={k => setActiveTab(k)}>
        <Tab.Content>
          <Tab.Pane eventKey="countries">
            {renderCountriesList()}
          </Tab.Pane>
          <Tab.Pane eventKey="countryDetails">
            {renderCountryDetails()}
          </Tab.Pane>
        </Tab.Content>
      </Tab.Container>
    </Container>
  );
};

export default ParticipateCountry;